import * as React from "react";
const SvgAbbrechen = (props) => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 256 256" {...props} aria-label="Abbrechen">
    <path
      fill="currentColor"
      d="M128 243.54c-63.71 0-115.54-51.83-115.54-115.54S64.29 12.46 128 12.46 243.54 64.29 243.54 128 191.71 243.54 128 243.54m0-216.08C72.56 27.46 27.46 72.56 27.46 128S72.56 228.54 128 228.54 228.54 183.44 228.54 128 183.44 27.46 128 27.46"
    />
    <path
      fill="currentColor"
      d="M165.29 80.1 128 117.39 90.71 80.1A7.502 7.502 0 1 0 80.1 90.71L117.39 128 80.1 165.29a7.502 7.502 0 1 0 10.61 10.61L128 138.61l37.29 37.29a7.502 7.502 0 1 0 10.61-10.61L138.61 128l37.29-37.29a7.502 7.502 0 1 0-10.61-10.61"
    />
  </svg>
);
export default SvgAbbrechen;
